import { Axios, setAuthToken } from "./config/Axios";

////// AUTHENTICATION //////
// Register User
export const registerUser = async (params) => {
  const response = await Axios.post("/auth/register", params);
  return response;
};

// Verify User
export const verifyAccount = async (params) => {
  const response = await Axios.post("admin/auth/verifyAccount", params);
  return response;
};

// Chagne Password
export const changePassword = async (params) => {
  const response = await Axios.post("admin/auth/forgot-password", params);
  return response;
};

// Login User
export const loginUser = async (params) => {
  const response = await Axios.post("/admin/auth/login", params);
  return response;
};

// export const fetchUserDetails = async () => {
//   const response = await Axios.get("/utility/fetch-user-details");
//   return response;
// };

// Get user Info
export const getUserInfo = async () => {
  setAuthToken();
  const response = await Axios.get("/admin/utils/admin-info");
  return response;
};

// export const updateUserDetails = async (params) => {
//   const response = await Axios.post("/utility/update-user-details", params);
//   return response;
// };

////// AUTHENTICATION //////
////// PRIVATE REQUESTS //////

// export const submitChatQuery = async (params) => {
//   setAuthToken();
//   const response = await Axios.post("/chat/text", params);
//   return response;
// };

// export const selectRoleplay = async (params) => {
//   setAuthToken();
//   const response = await Axios.post("/chat/select-roleplay", params);
//   return response;
// };

// export const acceptTnc = async () => {
//   setAuthToken();
//   const response = await Axios.get("/chat/accept-tnc");
//   return response;
// };

// export const getFeedback = async (params) => {
//   setAuthToken();
//   const response = await Axios.post("/chat/feedback", params);
//   return response;
// };

// export const upadteDuration = async (params) => {
//   setAuthToken();
//   const response = await Axios.patch("/utility/update-duration", params);
//   return response;
// };

// export const deleteRoleplay = async (params) => {
//   setAuthToken();
//   const response = await Axios.patch("/utility/delete-roleplay", params);
//   return response;
// };

// export const lastThreeRoles = async () => {
//   setAuthToken();
//   const response = await Axios.get("/utility/last-three-roleplays");
//   return response;
// };

// export const getRoleplays = async (params) => {
//   setAuthToken();
//   const response = await Axios.post("/utility/recent-roleplays", params);
//   return response;
// };

// export const getDefinedRoleplays = async () => {
//   setAuthToken();
//   const response = await Axios.get("/chat/get-roleplays");

//   return response;
// };

// export const getSuggestedRoleplays = async () => {
//   setAuthToken();
//   const response = await Axios.get("/chat/get-suggested-roleplays");
//   return response;
// };

// export const getDashboardCompetencyScores = async () => {
//   setAuthToken();
//   const response = await Axios.get("/utility/dashboard-cmp-scrcrd");
//   return response;
// };

// export const getDashboardCompetencyScoresForGraphs = async (params) => {
//   setAuthToken();
//   const response = await Axios.post("/utility/dashboard-competency-graphs", params);
//   return response;
// };

// export const getDashboardConversationSkills = async () => {
//   setAuthToken();
//   const response = await Axios.get("/utility/dashboard-converstaion-skills");
//   return response;
// };

// export const getDashboardRoleplayComparision = async () => {
//   setAuthToken();
//   const response = await Axios.get("/utility/dashboard-roleplay-comparision");
//   return response;
// };

// export const getDashboardMySummary = async () => {
//   setAuthToken();
//   const response = await Axios.get("/utility/dashboard-my-summary");
//   return response;
// };

// export const scheduleAccountDeletion = async () => {
//   setAuthToken();
//   const response = await Axios.get("/utility/delete-user-data");
//   return response;
// };

// export const cancelAccountDeletion = async () => {
//   setAuthToken();
//   const response = await Axios.get("/utility/cancel-delete-user-data");
//   return response;
// };

// export const getAudioFeedback = async (params) => {
//   setAuthToken();
//   const response = await Axios.post("/chat/feedback-audio", params);
//   return response;
// };

// export const updateCompetencies = async (params) => {
//   setAuthToken();
//   const response = await Axios.post("/utility/update-preffered-competencies", params);
//   return response;
// };

// export const fetchUserCompetencies = async () => {
//   setAuthToken();
//   const response = await Axios.get("/utility/fetch-preffered-competencies");
//   return response;
// };

// export const azureTts = async (text) => {
//   setAuthToken();
//   const response = await Axios.post("/utility/tts", text, {
//     headers: {
//       "Content-Type": "application/json",
//     },
//     responseType: "blob" // 👈 necessary for audio
//   });
//   return response;
// };

// export const uploadAudioBlobStorage = async (text) => {
//   setAuthToken();
//   const response = await Axios.post("/utility/upload-audio", text, {
//     headers: {
//       'Content-Type': 'multipart/form-data',
//     },
//   });
//   return response;
// };

// export const uploadImageBlobStorage = async (formData) => {
//   setAuthToken();
//   const response = await Axios.post("/utility/upload-image", formData, {
//     headers: {
//       'Content-Type': 'multipart/form-data',
//     },
//   });
//   return response;
// };

// export const getAiCoachQuestions = async () => {
//   setAuthToken();
//   const response = await Axios.get("/chat/ai-coach-questions");
//   return response;
// };

// export const getAiCoachAnswer = async (question) => {
//   setAuthToken();
//   const response = await Axios.post("/chat/ai-coach-answer", question);
//   return response;
// };

// export const submitReview = async (params) => {
//   setAuthToken();
//   const response = await Axios.post("/chat/submit-review", params);
//   return response;
// };

// export const getReviewStatus = async () => {
//   setAuthToken();
//   const response = await Axios.get("/chat/review-status");
//   return response;
// };

// export const getDashboardCompetencyInsights = async (params) => {
//   setAuthToken();
//   const response = await Axios.post("/utility/dashboard-competency-insights", params);
//   return response;
// };

// export const getDashboardTrainedCompetencies = async () => {
//   setAuthToken();
//   const response = await Axios.get("/utility/dashboard-trained-competencies");
//   return response;
// };

// // for storing roleinfo at every step

// // export const saveCustomizedStep = async (params) => {
// //   setAuthToken();
// //   console.log(params)
// //   console.log(await Axios.get('/customeroleplay/roleplay-not-null-columns'))
// //   const response = await Axios.post("/customeroleplay/save-step", params);

// //   return response;
// // };

// // For customizeRoleplay
// export const createCustomizedRolePlay = async (params) => {
//   setAuthToken();
//   const response = await Axios.post("/customeroleplay/create", params)
//   return response
// }
// export const updateCustomizedRolePlay = async ({ id, data }) => {
//   setAuthToken();
//   console.log(id)
//   const response = await Axios.put(`/customeroleplay/${parseInt(id)}`, data);
//   return response.data;
// };

export const getUsersStatsCardData = async (payload) => {
  setAuthToken();
  const response = await Axios.get("/admin/reporting/stats", {
    params: payload,
  });
  return response;
};

// Get All users
export const getAllUsers = async (payload) => {
  setAuthToken();
  const response = await Axios.get("/admin/userManagement/users", {
    params: payload,
  });
  return response;
};
// Template download for the USER upload and company uplaod
export const downloadUploadTemplate = async (type) => {
  setAuthToken();
  const response = await Axios.get("/admin/userManagement/downloadTemplate", {
    params: { type },
    responseType: "blob"
  });
  return response;
};

// Delete user
export const deleteUser = async (userId) => {
  setAuthToken();
  const response = await Axios.delete(`/admin/userManagement/user/${userId}`);
  return response.data;
};
export const activateUser = async (userId) => {
  setAuthToken();
  const response = await Axios.post(`/admin/userManagement/user/${userId}`);
  return response.data;
};

// Update user permission
export const updateUserPermission = async (userId, field, value) => {
  setAuthToken();
  const response = await Axios.patch(
    `/admin/userManagement/users/${userId}/toggle-permission`,
    {
      field,
      value,
    }
  );
  return response.data;
};

// Update profile image with file upload
export const updateUserProfileImage = async (userId, file) => {
  setAuthToken();

  const formData = new FormData();
  formData.append("profileImage", file);

  const response = await Axios.post(
    `/admin/userManagement/users/${userId}/profile-image`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};

// Update user field (token, dates, etc.)
export const updateUserField = async (userId, field, value) => {
  setAuthToken();
  const response = await Axios.patch(`/admin/userManagement/users/${userId}`, {
    [field]: value,
  });
  return response.data;
};

// from csv file upload
export const uploadCSVfile = async (formData) => {
  setAuthToken();

  const response = await Axios.post(
    "/admin/userManagement/users/upload-csv",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};
export const updateUserDepartments = async (userId, data) => {
  setAuthToken();
  return await Axios.patch(
    `/admin/userManagement/users/department/${userId}`,
    data
  );
};
export const getAssociaateCompanyDepartments = async (userId) => {
  setAuthToken();
  const response = await Axios.get(
    `/admin/userManagement/users/getDepartments/${userId}`,
  );
  return response.data || []
}

// For company parts;

// Get all companies
export const getCompanies = async (payload) => {
  setAuthToken();
  return await Axios.get("/admin/userManagement/companies", {
    params: payload,
  });
};

// Update company details
export const updateCompany = async (companyId, data) => {
  setAuthToken();
  return await Axios.patch(
    `/admin/userManagement/companies/${companyId}`,
    data
  );
};

// update company departments,
export const updateCompanyDepartments = async (companyId, data) => {
  setAuthToken();
  return await Axios.patch(
    `/admin/userManagement/companies/department/${companyId}`,
    data
  );
};

// Update company token allocation
export const updateCompanyToken = async ({ rowId, tokenData }) => {
  setAuthToken();
  const response = await Axios.put(
    `/admin/userManagement/companies/${rowId}/tokens`,
    { tokenData }
  );
  return response;
};

// Update subscription dates
export const updateCompanySubscriptionDates = async (companyId, dates) => {
  setAuthToken();
  const response = await Axios.put(
    `/admin/userManagement/companies/${companyId}/subscription`,
    dates
  );
  return response
};

// Upload company logo
export const uploadCompanyLogo = async (companyId, file) => {
  setAuthToken();
  const formData = new FormData();
  formData.append("logo", file);
  return await Axios.post(
    `/admin/userManagement/companies/${companyId}/logo`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};

// Delete company
export const deleteCompany = async (companyId) => {
  setAuthToken();
  return await Axios.delete(`/admin/userManagement/companies/${companyId}`);
};

// upload via csv
export const uploadCompanyCSVfile = async (formData) => {
  setAuthToken();
  const response = await Axios.post(
    "/admin/userManagement/companies/upload-csv",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response;
};

// for roleManagement
export const getAllUsersAllDetails = async () => {
  setAuthToken();
  const response = await Axios.get("/admin/rolemanagement/details");
  return response;
};

export const updateUserPermissions = async (userId, updatedPermissions) => {
  setAuthToken();
  const response = await Axios.post(
    `/admin/rolemanagement/update_permissions/${userId}`,
    {
      permissions: updatedPermissions,
    }
  );
  return response;
};

export const getScenarios = async (params) => {
  setAuthToken();
  const response = await Axios.get("/admin/roleplaymanagement/get_scenario", {
    params,
  });
  return response.data;
};

// for roleplayManagement
// add scenario
export const addScenario = async (payload) => {
  setAuthToken();
  const response = await Axios.post(
    "admin/roleplaymanagement/add_scenario",
    payload,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return response.data;
};

// edit scenario
export const editScenario = async (payload) => {
  setAuthToken();
  const response = await Axios.put(
    "admin/roleplaymanagement/edit_scenario", // corrected route
    payload, // send payload directly
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const editScenarioImage = async (file, roleplayId) => {
  setAuthToken();
  const formData = new FormData();
  formData.append("scenarioImage", file);
  formData.append("roleplayId", roleplayId);

  const response = await Axios.post(
    "admin/roleplaymanagement/edit-scenario/change-image", // corrected route
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};
export const uploadImageToScenario = async (formData) => {
  setAuthToken();
  const response = await Axios.post(
    "admin/roleplaymanagement/add-roleplay/image", // corrected route
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};

// getting details of roleplays
export const getCategories = async (language) => {
  setAuthToken();
  const response = await Axios.get("/admin/roleplaymanagement/get-categories", { params: language });
  return response.data;
};
export const getSubCategories = async ({ categoryId, language }) => {
  setAuthToken();
  const response = await Axios.get(
    `/admin/roleplaymanagement/get-subCategories/${categoryId}`, {
    params: {
      language
    }
  }
  );
  return response.data;
};
export const addCategories = async (name, language) => {
  setAuthToken();
  const response = await Axios.post(
    `/admin/roleplaymanagement/add-categories`,
    { name: name.trim(), selected_language: language },
    { headers: { "Content-Type": "application/json" } }
  );

  return response.data;
};
export const createRoleplays = async ({ data }) => {
  setAuthToken();
  const response = await Axios.post(
    `/admin/roleplaymanagement/create-roleplay`,
    { data },
    { headers: { "Content-Type": "application/json" } }
  );

  return response.data;
};
export const updateCatgoriesVisibility = async ({ category_id }) => {
  console.log(category_id)
  setAuthToken();
  const response = await Axios.post(`admin/roleplaymanagement/update-category-visibility/${category_id}`)
  return response.data;
}
export const updatePredefinedRoleplaysStepData = async (params) => {
  setAuthToken();
  const response = await Axios.put(
    `/admin/roleplaymanagement/update-stepdata`, params
    ,
    {
      headers: { "Content-Type": "application/json" }
    }
  );
  return response.data;
};
export const getPredefinedRoleplaysDeatils = async ({ roleplay_id, selectedLanguage }) => {
  setAuthToken();
  const response = await Axios.get(`admin/roleplaymanagement/get-predefined-details/${roleplay_id}`, {
    params: {
      selected_language: selectedLanguage
    }
  })

  return response.data;
}
export const publishPreDefinedRoleplays = async (params) => {
  setAuthToken();
  const response = await Axios.put(`admin/roleplaymanagement/publish`, params);
  return response;
}

export const getDetails = async (id) => {
  setAuthToken();
  const response = await Axios.get("admin/roleplaymanagement/get_details", {
    params: { id },
  });
  return response.data;
};

// delete scenario
export const deleteScenario = async (id) => {
  setAuthToken();
  const response = await Axios.delete(
    `/admin/roleplaymanagement/delete_scenario/${id}`
  );
  return response;
};
export const deleteRoleplays = async (params) => {
  const { roleplay_id } = params;
  setAuthToken();
  const response = await Axios.delete(
    `/admin/roleplaymanagement/delete-roleplay/${roleplay_id}`
  );
  return response;
};


// for visibility
export const getAllroleplaysForVisibility = async (params) => {
  setAuthToken();
  const response = await Axios.get("/admin/roleplaymanagement/get_roleplays", {
    params,
  });
  return response.data;
};
export const updateScenarioVisibility = async (id, visibility) => {
  setAuthToken();
  const response = await Axios.put(
    `/admin/roleplaymanagement/update_visibility/${id}`,
    {
      visibility,
    }
  );
  return response.data;
};

// for security and compliances routes
//..........................................
// Audit
// Get all audit logs data
export const getAllAuditLogs = async (payload) => {
  setAuthToken();
  const response = await Axios.get("/admin/security/get_audit_logs", {
    params: payload,
  });
  return response.data;
};

export const updateAuditLogsTable = async () => {
  setAuthToken();
  const response = await Axios.post("/admin/security/add_data_logs");
  return response;
};

export const getAllDataDeletionRequest = async (payload) => {
  setAuthToken();
  const response = await Axios.get("/admin/security/data_deletion_request", {
    params: payload,
  });
  return response.data;
};

// for approving
export const approveDataDeletion = async (requestId) => {
  setAuthToken();
  const response = await Axios.post(
    `/admin/security/data_deletion_request/${requestId}/approve`
  );
  return response.data;
};

// generateOTP
export const generateOTP = async (requestId) => {
  setAuthToken();
  const response = await Axios.post(
    `/admin/security/data_deletion_request/${requestId}/generate_otp`
  );
  return response.data;
};

//  Verify OTP
export const verifyOTP = async (requestId, otp, approverEmail) => {
  setAuthToken();
  const response = await Axios.post(
    `/admin/security/data_deletion_request/${requestId}/verify_otp`,
    { otp, approverEmail }
  );
  return response.data;
};

// for denying
export const denyDataDeletionRequest = async (id) => {
  setAuthToken();
  const response = await Axios.post(
    `/admin/security/data_deletion_request/${id}/deny`
  );
  return response;
};

// For managing content(CMS);
//   Get All Inspirational Videos

// Get all videos
export const getInspirationalData = async () => {
  setAuthToken();
  const response = await Axios.get("/admin/cms/get_inspirational_data");
  return response.data;
};

// Upload video file
export const uploadVideoFileInspirational = async (file, onProgress) => {
  if (!file) throw new Error("No file provided");
  setAuthToken();
  const formData = new FormData();
  formData.append("video", file);
  const response = await Axios.post("/admin/cms/upload_video", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (progressEvent) => {
      if (onProgress) {
        const percent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgress(percent);
      }
    },
  });
  return response.data;
};

// Upload video URL
export const uploadVideoUrlInspirational = async (url) => {
  if (!url) throw new Error("No URL provided");
  setAuthToken();
  const response = await Axios.post("/admin/cms/upload-url", { url });
  return response.data;
};

// Add new video
export const addInspirationalVideo = async (formData) => {
  setAuthToken();
  const response = await Axios.post("/admin/cms/inspirational/add", formData);
  return response.data;
};

// Update video
export const updateInspirationalVideo = async (id, formData) => {
  // console.log("Formdata: ", formData)
  setAuthToken();
  const response = await Axios.put(
    `/admin/cms/inspirational/update/${id}`,
    formData
  );
  return response.data;
};

// Delete video
export const deleteInspirationalVideo = async (id) => {
  setAuthToken();
  const response = await Axios.delete(`/admin/cms/inspirational/delete/${id}`);
  return response.data;
};
export const toggleInspirationalStatus = async (id, currentStatus) => {
  if (!id) throw new Error("ID is required");
  setAuthToken();
  const response = await Axios.put(
    `/admin/cms/inspirational/toggle_status/${id}`,
    {
      status: currentStatus,
    }
  );
  return response.data;
};

// for frequently asked questions
//  Get all FAQs
export const getAllFaqs = async () => {
  setAuthToken();
  const response = await Axios.get("/admin/cms/faqs/get");
  return response.data;
};

//  Add FAQ
export const addFaqs = async (payload) => {
  setAuthToken();
  const response = await Axios.post("/admin/cms/faqs/add", payload);
  return response.data;
};

//  Update FAQ
export const updateFaq = async (id, payload) => {
  setAuthToken();
  const response = await Axios.put(`/admin/cms/faqs/${id}`, payload);
  return response.data;
};

// Delete FAQ
export const deleteFaq = async (id) => {
  setAuthToken();
  const response = await Axios.delete(`/admin/cms/faqs/${id}`);
  return response.data;
};

// Toggle FAQ status (Publish <-> Draft)
export const toggleFaqStatus = async (id) => {
  setAuthToken();
  const response = await Axios.patch(`/admin/cms/faqs/${id}/toggle-status`);
  return response.data;
};

export const getAllTutorials = async () => {
  setAuthToken();
  const response = await Axios.get("/admin/cms/tutorials/get");
  return response.data;
};

// Add a new tutorial
export const addTutorial = async (tutorialData) => {
  setAuthToken();
  const response = await Axios.post("/admin/cms/tutorials", tutorialData);
  return response.data;
};
export const uploadVideoTutorials = async (file, onProgress) => {
  if (!file) throw new Error("No file provided");
  setAuthToken();
  const formData = new FormData();
  formData.append("video", file);
  const response = await Axios.post("/admin/cms/upload_video", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (progressEvent) => {
      if (onProgress) {
        const percent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgress(percent);
      }
    },
  });
  return response.data;
};

// Update an existing tutorial
export const updateTutorial = async (id, tutorialData) => {
  setAuthToken();
  const response = await Axios.put(`/admin/cms/tutorials/${id}`, tutorialData);
  return response.data;
};

// Delete a tutorial
export const deleteTutorial = async (id) => {
  setAuthToken();
  const response = await Axios.delete(`/admin/cms/tutorials/${id}`);
  return response.data;
};

// Publish a tutorial
export const publishTutorial = async (id) => {
  setAuthToken();
  const response = await Axios.patch(`/admin/cms/tutorials/${id}/publish`);
  return response.data;
};

// Unpublish a tutorial
export const unpublishTutorial = async (id) => {
  setAuthToken();
  const response = await Axios.patch(`/admin/cms/tutorials/${id}/unpublish`);
  return response.data;
};

// Watch a tutorial (if you track views)
export const watchTutorial = async (id) => {
  setAuthToken();
  const response = await Axios.post(`/admin/tutorials/${id}/watch`);
  return response.data;
};

// For uploading the thumbnail
export const upload_thumbnail = async (file, onProgress) => {
  if (!file) throw new Error("No file provided");

  setAuthToken(); // Ensure auth headers are included (same as your video upload)

  const formData = new FormData();
  formData.append("file", file);

  const response = await Axios.post("/admin/cms/upload_thumbnail", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (progressEvent) => {
      if (onProgress) {
        const percent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgress(percent);
      }
    },
  });

  return response.data; // returns { success, blobUrl, message }
};

// for dataAccessAndReport

export const getCompaniesForDataAccess = async (params) => {
  setAuthToken();
  const response = await Axios.get("/admin/dataAccess/get-companies", {
    params: {
      search: params.search,
    },
  });
  return response.data;
};

export const exportUsersExcelReport = async (params) => {
  setAuthToken();
  const response = await Axios.post(
    "/admin/dataAccess/export-users-excel",
    params
  );
  return response.data;
};

export const downloadExcelReport = async (id) => {
  setAuthToken();

  const response = await Axios.get(
    `/admin/dataAccess/download-excel-report/${encodeURIComponent(id)}`,
    {
      responseType: "blob", // Important for file download
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

export const exportCompaniesExcelReport = async (params) => {
  setAuthToken();
  const response = await Axios.post(
    "/admin/dataAccess/export-company-excel",
    params
  );
  return response.data;
};

export const exportUsersExcelReportHistory = async (payload) => {
  setAuthToken();
  const response = await Axios.get(
    "/admin/dataAccess/get-export-history",
    { params: payload }
  );
  return response.data;
};

export const getDepartmentsForDataAccess = async (params) => {
  setAuthToken();
  const response = await Axios.get("/admin/dataAccess/get-departments", {
    params: {
      company_id: params.company_id,
      search: params.search,
    },
  });
  return response.data;
};

export const getUserDetailsData = async (filters) => {
  setAuthToken();
  const response = await Axios.get("/admin/dataAccess/users_details", {
    params: {
      company_id: filters.company_id,
      department_id: filters.department_id,
      search: filters.search,
      page: filters.page,
      limit: filters.limit,
    },
  });
  return response.data;
};
export const getCompaniesWiseDetails = async (filters) => {
  setAuthToken();
  const response = await Axios.get("/admin/dataAccess/company_details", {
    params: {
      company: filters.company,
      department: filters.department,
      search: filters.search,
      fromDate: filters.fromDate,
      toDate: filters.toDate,
      page: filters.page,
      limit: filters.limit,
    },
  });
  return response.data;
};
export const getDepartmentWiseDetails = async (filters) => {
  setAuthToken();
  const response = await Axios.get("/admin/dataAccess/department_details", {
    params: {
      company: filters.company,
      department: filters.department,
      search: filters.search,
      fromDate: filters.fromDate,
      toDate: filters.toDate,
      page: filters.page,
      limit: filters.limit,
    },
  });
  return response.data;
};

// for getting the list of the companies
export const getCompaniesList = async () => {
  setAuthToken();
  const response = await Axios.get("/admin/reporting/get_companies");
  return response.data;
};
export const getCustomizedRoleplays = async (payload) => {
  setAuthToken();
  const response = await Axios.get(
    "/admin/reporting/get_customized_roleplays",
    {
      params: payload,
    }
  );
  return response.data;
};

export const getCompanyDetails = async (payload) => {
  setAuthToken();
  const response = await Axios.get("/admin/reporting/get-company-details", { params: payload });
  return response.data;
};

export const getMostUsedScenarios = async (payload) => {
  setAuthToken();
  const response = await Axios.get("/admin/reporting/scenarios/most-used", {
    params: payload,
  });
  return response;
};

export const getLeastUsedScenarios = async (payload) => {
  setAuthToken();
  const response = await Axios.get("/admin/reporting/scenarios/least-used", {
    params: payload,
  });
  return response;
};

// For competency trends
export const getCompetenciesTrendSummary = async (payload) => {
  setAuthToken();
  const response = await Axios.get(
    "/admin/reporting/competencies/trends-and-summary",
    {
      params: payload,
    }
  );
  return response;
};
// for heygenRelated data
export const getHeyGenUsageData = async (payload) => {
  setAuthToken();
  const response = await Axios.get("/admin/reporting/get_heyGen_usage", {
    params: payload,
  });
  return response.data;
};
// for escalation part in reporting and steering
export const getAllTicketsForReportingSteering = async (payload) => {
  setAuthToken();
  const response = await Axios.get("/admin/reporting/get_all_tickets", {
    params: payload,
  });
  return response.data;
};

// Token usage
export const getTotalTokenUsage = async (payload) => {
  setAuthToken();
  const response = await Axios.get(
    "/admin/reporting/tokens-usage-by-companies",
    {
      params: payload,
    }
  );
  return response;
};

export const getCompanyWiseTokenDetails = async (payload) => {
  setAuthToken();
  const response = await Axios.get("/admin/reporting/company_details", {
    params: payload,
  });
  return response;
};

// get active user based on company

export const companyWiseActiveUsers = async (
  companyId = null,
  department = null
) => {
  setAuthToken();
  try {
    let url = `/admin/reporting/company/active_users?companyId=${companyId}`;
    if (department) {
      url += `&department=${encodeURIComponent(department)}`;
    }
    const res = await Axios.get(url);
    if (res.data.success) {
      return res.data;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching company wise active users:", error);
    return [];
  }
};
export const companyWisePracticePerMonths = async (
  companyId = null,
  department = null
) => {
  setAuthToken();
  try {
    let url = `/admin/reporting/company/practice_per_month?companyId=${companyId}`;
    if (department) {
      url += `&department=${encodeURIComponent(department)}`;
    }
    const res = await Axios.get(url);
    if (res.data.success) {
      return res.data;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching company wise active users:", error);
    return [];
  }
};

export const companyTokenBudget = async (
  companyId = null,
  department = null
) => {
  setAuthToken();
  try {
    let url = `/admin/reporting/company/token_budget?companyId=${companyId}`;
    if (department) {
      url += `&department=${encodeURIComponent(department)}`;
    }
    const res = await Axios.get(url);
    if (res.data.success) {
      return res.data;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching company wise active users:", error);
    return [];
  }
};

// for escalationManagement
// 1 Get all tickets (basic info)
export const getAllTickets = async (filters) => {
  setAuthToken();
  const response = await Axios.get(`/admin/escalation/get_all_tickets`, {
    params: filters,
  });

  return response || []; // return the array for component mapping
};
export const getAllTypesCatgeories = async (filters) => {
  setAuthToken();
  const response = await Axios.get(`/admin/escalation/get_all_tickets_type`, {
    params: filters,
  });
  return response.data || [];
}
export const getAllCompanies = async () => {
  setAuthToken();
  const response = await Axios.get("/admin/escalation/get_all_companies");
  return response?.data || [];
};
// 2 Get ticket details by ID
export const getTicketById = async (payload) => {
  setAuthToken();
  const response = await Axios.get("/admin/escalation/get_ticket_details", {
    params: payload,
  });
  return response.data;
};

export const generateRoleplayPdf = async ({ roleplayId }) => {
  setAuthToken();
  const response = await Axios.get("/admin/escalation/generate_pdf", {
    params: { roleplayId },
    responseType: "arraybuffer",
    headers: { Accept: "application/pdf" },
  });
  return response.data;
};

// 3 Create a new ticket
// export const createTicket = async (ticketData) => {
//   setAuthToken();
//   const response = await Axios.post("/admin/escalation", ticketData);
//   return response.data;
// };
// 4 Update ticket status
export const updateTicketStatus = async (updatePayload) => {
  setAuthToken();
  const response = await Axios.patch(
    "/admin/escalation/update_status",
    updatePayload
  );
  return response;
};
// 5 Update other ticket details (attachments, notes, scenario, reported_issue, issue_stage)
export const updateTicketDetails = async (updatedData) => {
  setAuthToken();
  const response = await Axios.patch(
    "/admin/escalation/update_ticket_details",
    updatedData
  );
  return response.data;
};
// 6 Delete a ticket
export const deleteTicket = async (ticketId) => {
  setAuthToken();
  const response = await Axios.delete(`/admin/escalation/${ticketId}`);
  return response.data;
};
// 7 Trigger push notification
export const notifyTicket = async (ticketId, push_status) => {
  setAuthToken();
  const response = await Axios.post("/admin/escalation/notify", {
    ticketId,
    push_status,
  });
  return response.data;
};

// Get ALL notifications
export const getAllNotification = async () => {
  setAuthToken();
  const response = await Axios.get("/admin/notification/getall");
  return response.data;
};
// CreateNotification
export const CreateNotification = async (payload) => {
  setAuthToken();
  const response = await Axios.post("/admin/notification/create", payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
export const SaveNotificationDraft = async (payload) => {
  setAuthToken();
  const response = await Axios.post("/admin/notification/draft", payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
// Delete Notification
export const deleteNotification = async (id) => {
  setAuthToken();
  const response = await Axios.delete(`/admin/notification/delete/${id}`);
  return response.data;
};
// Update Notification
